import { CannabisIcon } from './CannabisIcon';

/**
 * author: Austin Andrews
 * id 4C2DC909-0C3F-431F-A37B-5B66C9F33E37
 * name cannabis
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cannabis.svg
 * tags
 * - Nature 
 * - Medical / Hospital 
 */
export const WeedIcon = CannabisIcon;
export default WeedIcon